import { GenIcon, IconType } from 'react-icons/lib';

const UfpbChalkboardTeacher: IconType = (props: any) =>
  GenIcon({
    attr: {
      viewBox: '0 0 512 512',
    },
    child: [
      {
        attr: {
          d: 'M 123.9082 2.0214844 C 98.548868 2.0214844 78.132815 25.912523 78.132812 55.589844 L 78.132812 105.46484 C 94.111386 92.398965 113.21786 82.96763 134.31445 78.214844 L 134.31445 67.931641 L 454.39844 67.931641 L 454.39844 319.7168 L 432.59375 319.7168 L 432.59375 292.52344 C 432.59375 282.47149 424.79893 274.37891 415.11523 274.37891 L 331.18164 274.37891 C 321.49794 274.37891 313.70117 282.47149 313.70117 292.52344 L 313.70117 319.7168 L 269.66797 319.7168 C 299.46266 333.40361 324.59534 356.4285 341.95703 385.33789 L 463.75195 385.33789 C 489.1113 385.33789 509.52734 361.44685 509.52734 331.76953 L 509.52734 55.589844 C 509.52734 25.912523 489.1113 2.0214844 463.75195 2.0214844 L 123.9082 2.0214844 z M 165.74805 111.92969 C 109.55058 111.92969 65.65625 155.82596 65.65625 212.02344 C 65.65625 267.28255 109.55058 312.11523 165.74805 312.11523 C 221.02801 312.11523 265.83984 267.3034 265.83984 212.02344 C 265.83984 156.74347 221.02801 111.92969 165.74805 111.92969 z M 132.38477 345.47852 C 58.681636 345.47852 -1.0722656 405.23045 -1.0722656 478.93359 C -1.0722656 497.35676 13.869791 512.29883 32.292969 512.29883 L 299.20312 512.29883 C 317.62629 512.29883 332.56836 497.35676 332.56836 478.93359 C 332.56836 405.22002 272.82489 345.47852 199.11133 345.47852 L 132.38477 345.47852 z ',
        },
        child: [],
        tag: 'path',
      },
    ],
    tag: 'svg',
  })(props);

export default UfpbChalkboardTeacher;
